/* @flow */
import * as React from 'react';
import { themr } from 'react-css-themr';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { translate } from 'react-i18next';

import { Session } from 'common/models/internal/Session';
import { dashboardColors } from 'common/enums/ColorEnum';
import { Button, ButtonTypes } from 'common/components/core/button';
import { withRouter } from 'common/components/core/router';
import PasswordExpiryMessage from './PasswordExpiryMessage';
import { PasswordExpiryNotificationActions } from 'common/redux/actions/password';

import Icon from 'common/components/core/icon';

import {
    clientIdSelector,
    sessionSelector,
    personnelIdSelector
} from 'common/redux/selectors/sessionSelector';

import defaultTheme from './PasswordExpiryNotification.scss';

type Props = {
    theme: Object,
    personnelId: string,
    clientId: string,
    session: Session,
    doItLater: (clientId: string, personnelId: string) => void,
    hideNotification: (clientId: string, personnelId: string) => void,
    history: Object,
    location: Object,
    t: Function
};

class PasswordExpiryNotification extends React.Component<Props> {
    timerId: ?TimeoutID;

    _handleDoItLater = () => {
        const { props } = this;
        props.hideNotification(props.clientId, props.personnelId);
        props.doItLater(props.clientId, props.personnelId);
    };

    _handleUpdateNow = () => {
        const { props } = this;
        props.hideNotification(props.clientId, props.personnelId);
        props.history.push({
            pathname: `/client/${props.clientId}/mysettings`,
            search: queryString.stringify({
                changePassword: null
            })
        });
    };

    render() {
        const { theme, session, t } = this.props;

        return (
            <div className={theme.container}>
                <div className={theme.msgContainer}>
                    <Icon icon="lock" className={theme.msgIcon} />
                    {session.passwordMetadata.expiryDate ? (
                        <PasswordExpiryMessage
                            expiryDate={session.passwordMetadata.expiryDate}
                        />
                    ) : null}
                </div>
                <div className={theme.actions}>
                    <Button
                        semibold
                        label={t('passwordExpiry.actions.doItLater')}
                        onClick={this._handleDoItLater}
                        color={dashboardColors.darkSkyBlue.name}
                        className={theme.doItLaterBtn}
                    />
                    <Button
                        semibold
                        buttonType={ButtonTypes.Solid}
                        label={t('passwordExpiry.actions.updateNow')}
                        color={dashboardColors.darkSkyBlue.name}
                        inverted={false}
                        onClick={this._handleUpdateNow}
                    />
                </div>
            </div>
        );
    }
}

export default compose(
    translate('translations'),
    themr('PasswordExpiryNotification', defaultTheme),
    connect(
        (state, props) => {
            return {
                clientId: clientIdSelector(state, props),
                personnelId: personnelIdSelector(state),
                session: sessionSelector(state)
            };
        },
        {
            doItLater: PasswordExpiryNotificationActions.doItLater,
            hideNotification: PasswordExpiryNotificationActions.hide
        }
    ),
    withRouter
)(PasswordExpiryNotification);
